import { ListItem } from "../types";

export const List = <ItemType, MetaType extends { key: string }>({
  items,
  // getArtConfig,
  Item,
  style = "flexible",
  ...props
}: {
  Item: (props: {
    item: ListItem<ItemType, MetaType>;
    style: "flexible" | "row";
  }) => JSX.Element;
  items: ListItem<ItemType, MetaType>[];
  noItems: JSX.Element;
  style?: "flexible" | "row";

  // getItemProps: (
  //   item: ListItem<ItemType, MetaType>,
  //   __meta?: MetaType
  // ) => Partial<typeof Parmeters<Item{}>;
}) => (
  <div
    className={
      style === "flexible"
        ? "flex flex-wrap md:justify-center justify-between sm:mx-5 m-2 lg:mx-[5vw] 2xl:mx-[150px] gap-2"
        : ""
    }
  >
    {items?.length
      ? items.map((item) => (
          <Item
            style={style}
            item={item}
            // artConfig={getArtConfig?.(art, __meta)}
            key={item.__meta.key}
          />
        ))
      : props.noItems}
  </div>
);
